var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoTablero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_13166",
    "data-name": "Grupo 13166",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.485,
    height: 15.484,
    viewBox: "0 0 15.485 15.484",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_30981",
    "data-name": "Trazado 30981",
    d: "M374.883,335.092h-1.936a2.581,2.581,0,0,0-2.581,2.581v1.935a2.581,2.581,0,0,0,2.581,2.581h1.936a2.581,2.581,0,0,0,2.581-2.581v-1.935A2.581,2.581,0,0,0,374.883,335.092Zm1.29,4.516a1.291,1.291,0,0,1-1.29,1.29h-1.936a1.291,1.291,0,0,1-1.29-1.29v-1.935a1.29,1.29,0,0,1,1.29-1.29h1.936a1.29,1.29,0,0,1,1.29,1.29Z",
    transform: "translate(-370.366 -335.092)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_30982",
    "data-name": "Trazado 30982",
    d: "M386.29,335.092h-1.935a2.58,2.58,0,0,0-2.581,2.581v1.935a2.58,2.58,0,0,0,2.581,2.581h1.935a2.58,2.58,0,0,0,2.581-2.581v-1.935A2.58,2.58,0,0,0,386.29,335.092Zm1.29,4.516a1.29,1.29,0,0,1-1.29,1.29h-1.935a1.291,1.291,0,0,1-1.29-1.29v-1.935a1.29,1.29,0,0,1,1.29-1.29h1.935a1.29,1.29,0,0,1,1.29,1.29Z",
    transform: "translate(-373.386 -335.092)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_30983",
    "data-name": "Trazado 30983",
    d: "M374.883,346.5h-1.936a2.581,2.581,0,0,0-2.581,2.581v1.935a2.581,2.581,0,0,0,2.581,2.581h1.936a2.581,2.581,0,0,0,2.581-2.581V349.08A2.581,2.581,0,0,0,374.883,346.5Zm1.29,4.516a1.29,1.29,0,0,1-1.29,1.29h-1.936a1.29,1.29,0,0,1-1.29-1.29V349.08a1.291,1.291,0,0,1,1.29-1.29h1.936a1.291,1.291,0,0,1,1.29,1.29Z",
    transform: "translate(-370.366 -338.112)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_30984",
    "data-name": "Trazado 30984",
    d: "M386.29,346.5h-1.935a2.58,2.58,0,0,0-2.581,2.581v1.935a2.58,2.58,0,0,0,2.581,2.581h1.935a2.58,2.58,0,0,0,2.581-2.581V349.08A2.58,2.58,0,0,0,386.29,346.5Zm1.29,4.516a1.29,1.29,0,0,1-1.29,1.29h-1.935a1.29,1.29,0,0,1-1.29-1.29V349.08a1.291,1.291,0,0,1,1.29-1.29h1.935a1.29,1.29,0,0,1,1.29,1.29Z",
    transform: "translate(-373.386 -338.112)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoTablero);
export default __webpack_public_path__ + "static/media/Icono-Tablero.7867ba24055d8ea4e26f97fbb74d0236.svg";
export { ForwardRef as ReactComponent };